import clsx from 'clsx'
import React from 'react'
import styles from './AbonnementPrix.module.css'

const AbonnementPrix = ({
  mobile,
  discount,
  favorite,
  promotion,
  abonnement
}) => {
  const markdown = (discount)
    ? discount(abonnement.price).toFixed(2)
    : promotion
  return (
    <div
      className={
        clsx({
          [styles.mobile]: mobile,
          [styles.container]: true,
          [styles.favorite]: favorite,
          [styles.promotion]: (markdown > 0)
        })
      }
    >
      <div className={styles.name}>
        {abonnement.name}
      </div>
      {
        (markdown > 0)
          ? <div className={styles.prix}>
              <span className={styles.old}>{abonnement.price}€</span>
              <span>{markdown}€</span>
            </div>
          : <div className={styles.prix}>{abonnement.price}€</div>
      }
      <div className={styles.duration}>par mois</div>
    </div>
  )
}

export default AbonnementPrix
